import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from 'shared/hooks'

interface CopyToClipboardProps {
  content: string
  onlyIcon?: boolean
}

const CopyToClipboardButton = ({ content, onlyIcon }: CopyToClipboardProps) => {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const showLabel = !onlyIcon && !isMobile

  const handleCopyClick = (content: string) => {
    enqueueSnackbar(t('addedToClipboard'), {
      autoHideDuration: 2000,
    })
    navigator.clipboard.writeText(content)
  }
  return (
    <Button
      variant={onlyIcon ? 'text' : 'outlined'}
      startIcon={showLabel ? <ContentCopyIcon /> : undefined}
      fullWidth={false}
      onClick={event => {
        event.stopPropagation()
        handleCopyClick(content)
      }}
    >
      {showLabel ? t('copy') : <ContentCopyIcon />}
    </Button>
  )
}

export default CopyToClipboardButton
